import {
    type ReactNode,
    type FC,
    useRef
} from "react";
import {
    Animated,
    View
} from "react-native";
import type {
    DataTableDetailProps
} from "./type";
import {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    useDataTableContext
} from "../../context";
import CollapseRegion from "../../../collapsible/internal/collapseRegion";
import Table from "../../../table";

const DataTableDetail: FC<DataTableDetailProps> = ({
    customTheme: customThemeProp,
    controlsId,
    isExpanded,
    colSpan,
    detail,
    label
}) => {
    const context = useDataTableContext({
        part: "Content"
    });

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        shapeConfigs,
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    const detailRef = useRef<ReactNode>(detail);

    const opacity = useAnimatedState({
        intent: isExpanded ? "expand" : "collapse",
        value: isExpanded ? 1 : 0,
        customTheme
    });

    const {
        region: regionDynamicStyle
    } = useStyles({
        shapeConfigs,
        radiuses,
        colors,
        spaces
    });

    if(isExpanded) {
        detailRef.current = detail;
    }

    return <CollapseRegion
        customTheme={customTheme}
        isOpen={isExpanded}
    >
        <Animated.View
            style={{
                opacity
            }}
        >
            <Table.Row>
                <Table.Cell
                    colSpan={colSpan}
                >
                    <View
                        aria-label={localize("data-table-row-details", [
                            label
                        ])}
                        style={regionDynamicStyle}
                        id={controlsId}
                        role="region"
                    >
                        {detailRef.current}
                    </View>
                </Table.Cell>
            </Table.Row>
        </Animated.View>
    </CollapseRegion>;
};
export default DataTableDetail;
